import React from 'react';

const FourFiveColumnWithDetailContent =
  ({ DetailContentFn, FourFiveColumnContentFn, mapVariantToProps, mapVariantToClassName }: any) =>
  ({ title, columns = [], theme, className }: any) => (
    <FourFiveColumnContentFn
      title={title}
      className={className}
      theme={theme}
      columns={columns.map((content: any) => (
        <DetailContentFn
          content={content}
          mapVariantToProps={mapVariantToProps}
          mapVariantToClassName={mapVariantToClassName}
          theme={theme}
        />
      ))}
    />
  );

export default FourFiveColumnWithDetailContent;
